import React from 'react'
import UserRoleTableHead from './UserRoleTableHead';
import UserRoleTableRow from './UserRoleTableRow';
import './user-table.scss';

const UserRoleTable = ({ UserRoleData = [], onRowClick, selectedRow }) => {
  return (
    <div className="user-table">
      <div className="user-table__wrapper">
        <UserRoleTableHead />
        <UserRoleTableRow userRoleData={UserRoleData} onRowClick={onRowClick} selectedRow={selectedRow} />
      </div>
    </div>
  )
}
export default UserRoleTable;
